import axios from 'axios';
import {
  GET_TRANSITION_RULES,
  CREATE_TRANSITION_RULES,
  GET_SUB_STATUSES,
  GET_MAIN_STATUSES,
  LIST_TRANSITION_RULES,
  LIST_TRANSITION_TYPES,
  ASSIGN_TRANSITION_RULES,
  get_headers,
  get_project_id,
  get_token
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';

export default {
  name: 'CreateTransitionRules',
  mixins: [alert_mixin],
  data:() => ({
    headers: get_headers(),
      token: get_token(),
      project_id: get_project_id(),
      active_status_tab: 0,
      main_stages: [],
      editing_stage: '',
      selected_transitions: [],
      selected_stage: '',
      filtered_stages: [],
      loading: false,
      error: null,
      new_rule: {
        name: '',
        expression: ''
      },
      rules: new Map(),
      rule_id: null,
      show_rule_modal: false,
      current_editing_stage: null,
      available_rules: []
  }),
  computed: {
    current_rules() {
      const status_name = this.main_stages[this.active_status_tab]?.name || '';
      return this.get_current_rules(status_name);
    },
    sub_status_options() {
      const current_main_status = this.main_stages[this.active_status_tab];
      if (!current_main_status) return [];
      return current_main_status.sub_stages.map(sub_status => ({
        value: String(sub_status.name || ''),
        label: String(sub_status.name || '')
      }));
    },
    current_main_stage_id() {
      return this.main_stages[this.active_status_tab]?.id || null;
    }
  },
  mounted() {
    this.get_enquiry_main_statuses();
    this.fetch_available_rules();
    this.get_transition_types();
  },
  methods: {
    validate_status_name(status_name) {
      return typeof status_name === 'string' && 
             this.main_stages.some(s => s.name === status_name);
    },
    
    validate_stage_name(stage) {
      return typeof stage === 'string' && 
             this.filtered_stages.includes(stage);
    },
    
    update_filtered_stages() {
      const current_main_status = this.main_stages[this.active_status_tab];
      if (!current_main_status) return;
      
      const sub_stages = current_main_status.sub_stages;
      
      if (sub_stages.length === 1) {
        this.filtered_stages = this.main_stages.map(stage => String(stage.name || ''));
      } else {
        this.filtered_stages = sub_stages
          .filter(sub_stage => sub_stage.name !== this.selected_stage)
          .map(sub_stage => String(sub_stage.name || ''));
      }
      
      const status_name = current_main_status.name;
      if (!this.rules.has(status_name)) {
        this.rules.set(status_name, new Map());
      }
      
      this.filtered_stages.forEach(stage => {
        if (!this.rules.get(status_name).has(stage)) {
          this.rules.get(status_name).set(stage, []);
        }
      });
    },
    
    change_status_tab(index) {
      if (index < 0 || index >= this.main_stages.length) return;
      
      this.active_status_tab = index;
      this.selected_stage = '';
      const status = this.main_stages[index];
      
      this.rule_id = status.id;
      this.load_sub_statuses_for_main_status(status.id);
    
      if (!this.rules.has(status.name)) {
        this.rules.set(status.name, new Map());
      }
      
      this.get_transition_rules({ main_status_id: status.id });
      this.filtered_stages = [];
    },
    
    get_current_rules(status_name) {
      if (!this.validate_status_name(status_name)) {
        return new Map();
      }
      
      if (!this.rules.has(status_name)) {
        this.rules.set(status_name, new Map());
      }
      
      return Object.fromEntries(this.rules.get(status_name));
    },
      
    get_enquiry_main_statuses() {
        axios.get(GET_MAIN_STATUSES, { headers: this.headers })
        .then(response => {
          this.main_stages = response.data.data.map(status => ({
            id: Number(status.id) || 0,
            name: String(status.status || ''),
            expanded: false,
            sub_stages: []
          }));
          
          if (this.main_stages.length > 0) {
            this.change_status_tab(0);
          }
        })
        .catch(error => {
          this.show_error(`Error fetching main statuses: ${error.response?.data?.message}`);
        });
    },

    load_sub_statuses_for_main_status(main_status_id) {
        const params = {
          main_status_id: Number(main_status_id) || 0
        };
      
        axios.get(GET_SUB_STATUSES, { 
          headers: this.headers,
          params: params
        })
        .then(response => {      
          const sub_statuses = response.data.data;
          const main_stage = this.main_stages.find(stage => stage.id === main_status_id);
          if (main_stage) {
            main_stage.sub_stages = sub_statuses.map(sub_status => ({
              id: Number(sub_status.id) || 0,
              name: String(sub_status.enquiry_sub_status || ''),
              description: String(sub_status.description || ''),
              is_mandatory: Boolean(sub_status.is_mandatory) || false,
              editing: false
            }));
          }
        })
        .catch(error => {
          this.show_error(`Error fetching sub statuses: ${error.response?.data?.message}`);
      });
    },

    open_rule_modal(stage) {
      this.current_editing_stage = stage;
      this.new_rule = { name: '', expression: '' };
    },

    save_rule() {
      const rule_id = this.new_rule.selected_rule_id;
      if (!rule_id) {
        return this.show_error('Please pick a rule from the dropdown');
      }

      const chosen = this.available_rules.find(r => r.id === rule_id);
      if (!chosen) {
        return this.show_error('Invalid rule selected');
      }

      const ms = this.main_stages[this.active_status_tab];
      const sub = ms.sub_stages.find(s => s.name === this.current_editing_stage);
      if (!sub) {
        return this.show_error('Sub-status not found');
      }

      // Update UI
      const map = this.rules.get(ms.name) || new Map();
      const arr = map.get(this.current_editing_stage) || [];
      map.set(this.current_editing_stage, [
        ...arr,
        { name: chosen.name, expression: chosen.expression }
      ]);
      this.rules.set(ms.name, map);

      // Persist
      axios
        .post(
          ASSIGN_TRANSITION_RULES,
          { sub_status_id: sub.id, rule_id: chosen.id,  
            transition_type_id: this.new_rule.selected_transition_type_id
          },
          { headers: this.headers }
        )
        .then(() => this.show_success(`Assigned "${chosen.name}" to ${sub.name}`))
        .catch(err =>
          this.show_error(`Failed to assign rule: ${err.response?.data?.message}`)
        );

      this.close_modal('create_rule_modal');
    },

    save_changes() {
      const current_stage = this.current_editing_stage;
      if (!current_stage) {
        this.show_error('Please select a stage to save rules for');
        return;
      }
    
      const status_name = this.main_stages[this.active_status_tab].name;
      const stage_rules = this.rules.get(status_name)?.get(current_stage) || [];
      
      if (stage_rules.length === 0) {
        this.show_error(`No rules defined for ${current_stage}`);
        return;
      }
    
      const payload = {
        rule_name: stage_rules[0].name,
        rule_expression: stage_rules[0].expression
      };
    
      axios.post(CREATE_TRANSITION_RULES, payload, { headers: this.headers })
        .then(response => {
          if(response.data.status === 'success') {
            this.show_success(`Rules for ${current_stage} saved successfully`);
        }
        })
        .catch(error => {
            this.show_error(`Error fetching sub statuses: ${error.response?.data?.message}`);
        })
    },

    fetch_available_rules() {
      axios
        .get(LIST_TRANSITION_RULES, { headers: this.headers })
        .then(({ data }) => {
          this.available_rules = data.data.map(r => ({
            id: r.id,
            name: r.rule_name,
            expression: r.rule_expression
          }));
        })
        .catch(err => {
          this.show_error(
            `Could not load rule list: ${err.response?.data?.message}`
          );
        });
    },

    get_transition_types() {
      axios.get(LIST_TRANSITION_TYPES, { headers: this.headers })
        .then(({ data }) => {
          this.available_types = data.data.map(t => ({
            id: t.id,
            type: t.type
          }));
        })
        .catch(err => this.show_error(`Failed loading types: ${err}`));
    },

    get_transition_rules(params = {}) {
      this.loading = true;

      axios.get(GET_TRANSITION_RULES, {
        headers: this.headers,
        params  // now accepts { main_status_id }
      })
      .then(response => {
        const list = response.data.data || [];
        const status_name = this.main_stages[this.active_status_tab].name;
        const stage_map = new Map();

        list.forEach(rule => {
          if (!stage_map.has(rule.stage)) {
            stage_map.set(rule.stage, []);
          }
          stage_map.get(rule.stage).push({
            name: rule.name,
            expression: rule.expression
          });
        });

        this.rules.set(status_name, stage_map);
      })
      .catch(error => {
        this.show_error(`Error loading transition rules: ${error.response?.data?.message}`);
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },
  watch: {
    selected_stage(new_val) {
      if (new_val) {
        this.update_filtered_stages();
      }
    },
    'main_stages[active_status_tab].sub_stages': {
      handler() {
        if (this.selected_stage) {
          this.update_filtered_stages();
        }
      },
      deep: true
    }
  }
}